<template>
  <div>
    <b-container fluid class="p-0 m-0">
      <b-row>
        <b-col class="m-0 p-0">
          <h4 class="text-center fhe p-3">Add Admin <span class="smh"></span></h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="m-1 p-0">
          <form @submit.prevent="addadmin">
            <b-form-group label="User Email" class="label" label-for="target">
              <b-form-input type="text" id="title" v-model="user.email"></b-form-input>
            </b-form-group>

            <b-form-group label="User Email" v-if='details.clearance_level == 5' class="label" label-for="target">
              <b-form-select id="target" v-model="user.level" :options="levels" required>
                <b-form-select-option value="null"
                  >--Clearance Level--</b-form-select-option
                >
              </b-form-select>
            </b-form-group>

            <b-form-group label="Clearance Title" label-for="title" class="label">
              <b-form-input type="text" id="title" v-model="user.title"></b-form-input>
            </b-form-group>

            <b-form-group>
              <div class="text-center">
                <b-overlay
                  :show="sending"
                  rounded
                  opacity="0.6"
                  spinner-small
                  spinner-variant="primary"
                  class=""
                >
                  <b-button
                    :disabled="sending"
                    type="submit"
                    class="p-3 text-bold"
                    variant="primary"
                  >
                    Add Admin
                  </b-button>
                </b-overlay>
              </div>
            </b-form-group>
          </form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  components: {},

  data() {
    return {
      user: this.getForm(),
      sending: false,
      levels: [0, 1, 2, 3, 4, 5],
    };
  },
  computed: {
    ...mapState({
        users: (state) => state.admin.allusers,
        details : state => state.loginmaster.details
    }),
    emails() {
      let emailss = this.users;
      return emailss.map((x) => x.email);
    },
  },
  methods: {
    ...mapActions("admin", ["addAdmin"]),
    getForm() {
      return {
        email: null,
        title: "",
        level: null,
      };
    },
    addadmin() {
      this.sending = true;
      return this.addAdmin(this.user).then(() => {
        this.sending = false;

        this.$bvModal
          .msgBoxOk("Admin added Successfully.", {
            title: "Operation Successful",
            size: "xs",
            centered: true,
          })
          .then(() => {});
      });
    },
  },
};
</script>

<style scoped>
.fhe {
  background-color: #00377b;
  color: white;
  border-radius: 20px 20px 0px 0px;
  font-weight: bold;
}
</style>
